export const themeOptions = [
    { key: "3024-day", value: "3024-day", text: "3024 Day" },
    { key: "3024-night", value: "3024-night", text: "3024 Night" },
    { key: "abcdef", value: "abcdef", text: "abcdef" },
    { key: "ambianceMobile", value: "ambianceMobile", text: "Ambiance Mobile" },
    { key: "ayu-dark", value: "ayu-dark", text: "Ayu Dark" },
    { key: "ayu-mirage", value: "ayu-mirage", text: "Ayu Mirage" },
    { key: "base16-dark", value: "base16-dark", text: "Base 16 Dark" },
    { key: "base16-light", value: "base16-light", text: "Base 16 Light" },
    { key: "bespin", value: "bespin", text: "Bespin" },
    { key: "blackboard", value: "blackboard", text: "Blackboard" },
    { key: "cobalt", value: "cobalt", text: "Cobalt" },
    { key: "colorforth", value: "colorforth", text: "Colorforth" },
    { key: "darcula", value: "darcula", text: "Darcula" },
    { key: "dracula", value: "dracula", text: "Dracula" },
    { key: "duotone-dark", value: "duotone-dark", text: "Duotone Dark" },
    { key: "eclipse", value: "eclipse", text: "Eclipse" },
    { key: "elegant", value: "elegant", text: "Elegant" },
    { key: "erlang-dark", value: "erlang-dark", text: "Erlang Dark" },
    { key: "gruvbox-dark", value: "gruvbox-dark", text: "Gruvbox Dark" },
    { key: "hopscotch", value: "hopscotch", text: "Hopscotch" },
    { key: "icecoder", value: "icecoder", text: "Icecoder" },
    { key: "idea", value: "idea", text: "Idea" },
    { key: "isotope", value: "isotope", text: "Isotope" },
    { key: "lesser-dark", value: "lesser-dark", text: "Lesser Dark" },
    { key: "liquibyte", value: "liquibyte", text: "Liquibyte" },
    { key: "lucario", value: "lucario", text: "Lucario" },
    { key: "material-darker", value: "material-darker", text: "Material Darker" },
    { key: "material-ocean", value: "material-ocean", text: "Material Ocean" },
    { key: "material-palenight", value: "material-palenight", text: "Material Palenight" },
    { key: "mbo", value: "mbo", text: "Mbo" },
    { key: "mdn-like", value: "mdn-like", text: "Mdn Like" },
    { key: "monokai", value: "monokai", text: "Monokai" },
    { key: "moxer", value: "moxer", text: "Moxer" },
    { key: "neo", value: "neo", text: "Neo" },
    { key: "night", value: "night", text: "Night" },
    { key: "nord", value: "nord", text: "Nord" },
    { key: "oceanic-next", value: "oceanic-next", text: "Oceanic Next" },
    { key: "panda-syntax", value: "panda-syntax", text: "Panda Syntax" },
    { key: "paraiso-dark", value: "paraiso-dark", text: "Paraiso Dark" },
    { key: "paraiso-light", value: "paraiso-light", text: "Paraiso Light" },
    { key: "pastel-on-dark", value: "pastel-on-dark", text: "Pastel on Dark" },
    { key: "railscasts", value: "railscasts", text: "Railscasts" },
    { key: "rubyblue", value: "rubyblue", text: "Rubyblue" },
    { key: "seti", value: "seti", text: "Seti" },
    { key: "shadowfox", value: "shadowfox", text: "Shadowfox" },
    { key: "solarized", value: "solarized", text: "Solarized" },
    { key: "ssms", value: "ssms", text: "ssms" },
    { key: "the-matrix", value: "the-matrix", text: "The Matrix" },
    { key: "tomorrow-night-bright", value: "tomorrow-night-bright", text: "Tomorrow Night Bright" },
    { key: "tomorrow-night-eighties", value: "tomorrow-night-eighties", text: "Tomorrow Night Eighties" },
    { key: "ttcn", value: "ttcn", text: "ttcn" },
    { key: "twilight", value: "twilight", text: "Twilight" },
    { key: "vibrant-ink", value: "vibrant-ink", text: "Vibrant Ink" },
    { key: "xq-dark", value: "xq-dark", text: "XQ Dark" },
    { key: "xq-light", value: "xq-light", text: "XQ Light" },
    { key: "yeti", value: "yeti", text: "Yeti" },
    { key: "yonce", value: "yonce", text: "Yonce" },
    { key: "zenburn", value: "zenburn", text: "Zenburn" },
  ];